import { useEffect, useState } from "react";
import './App.css';

export default function App() {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState({}); // store expanded state per card
  const [searchTerm, setSearchTerm] = useState(""); // store search input
  const api_endpoint = "https://api.ieatforms.com"
  const cdn_endpoint = "https://cdn.ieatforms.com"
  useEffect(() => {
    fetch(`${api_endpoint}/form_models`)
      .then((res) => res.json())
      .then((data) => setItems(data))
      .catch(() => {
        setItems([
          { link: "g-845", name: "Form G-845", description: "Verification Request" },
          { link: "i-130", name: "Form I-130", description: "Petition for Alien Relative" },
          { link: "i-485", name: "Form I-485", description: "Application to Register Permanent Residence" },
        ]);
      });
  }, []);

  const toggleCard = (link) => {
    setExpanded(prev => ({ ...prev, [link]: !prev[link] }));
  };

  const calculate_file_location = (file_name, modified_edition = "", link = "") => {
    let fileBaseUrl = `${cdn_endpoint}/files/forms`;
    return modified_edition === "" ? fileBaseUrl + "/" + file_name : fileBaseUrl + "/archives/" + link.slice(1) + file_name
  }
  const calculate_archives_location = (link) => {
    let fileBaseUrl = `${cdn_endpoint}/files/forms`;
    return fileBaseUrl + "/archives/" + link.slice(1)
  }
  const calculate_file_names = (item, isDownload = false, optional_index = -1, modified_edition = "", isUnlocked = false) => {
    let isUnlockedText = isDownload == true ? "" : isUnlocked == true ? "_unlocked" : "_locked"
    let file_name = optional_index === -1 ? item.filename : item.filename.split(";")[optional_index]
    let edition_date = modified_edition !== "" ? modified_edition.replace(/\//g, "-") : item.edition_date.replace(/\//g, "-")
    return file_name + "_" + edition_date + isUnlockedText + ".pdf"
  }

  const getLinks = (item) => {
    if (item.filename && item.filename !== "null") {
      const filenames_split = item.filename.split(";");

      return filenames_split.map((name, index) => {
        const unlocked = calculate_file_names(item, false, index, "", true)
        const unlocked_path = calculate_file_location(unlocked)
        return (
          <p key={index}>
            <a href={unlocked_path} target="_blank" rel="noopener noreferrer">
              {unlocked}
            </a>
          </p>
        );
      });
    }

    return null; // return nothing if no filename
  };

  const getFieldInfo = (item) => {
    return (
      <div className={`card-content ${expanded[item.link] ? "expanded" : ""}`}>
        <p><strong>PLEASE REFERENCE USCIS:  </strong>
        <a
          href={`https://www.uscis.gov${item.link}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {`https://www.uscis.gov${item.link}`}
        </a></p>
        <p>{item.description}</p>
        
        {item.edition_date && <p><strong>Edition Date:</strong> {item.edition_date}</p>}
        
        <p>
          <strong>File(s):</strong> {getLinks(item)}
        </p>
        {item.past_editions && item.past_editions.length > 0 && (
          <p><strong>Past Editions Archives:</strong> 
          <a
          href={`${calculate_archives_location(item.link)}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {`${calculate_archives_location(item.link)}`}
          </a>
          </p>
        )}
      </div>
    );
  };

  // Filter items based on search term
  const filteredItems = items.filter(item => {
    const normalize = str => str.toLowerCase().replace(/[^a-z0-9]/g, ''); // remove everything except letters and numbers
    return normalize(item.name).includes(normalize(searchTerm));
  });

  return (
    <div className="app-container">
      <div className="disclaimer">
        ⚠️ This is an unofficial website and is not affiliated with USCIS or any government body. 
        It should not be guaranteed that any forms are the correct edition nor accurate. 
        Please visit the USCIS website to ensure you have the correct form.
      </div>
      <div className="disclaimer">
        ⚠️ Make sure to fill out all required fields, that may not auto-populate after unlocking this form!
      </div>
      <header>
        <h1>I eat forms: <span className="highlight">Edible Forms</span></h1>
        <p>Hello, thank you for visiting my website. I am Endless-Space on reddit. I recently started forms for my K1 Visa and some are uneditable, and I got annoyed so I wanted to create something that could possibly make this easier for people. Just be careful when filling this out and make sure it is the correct edition and proper. I kept saying edible forms instead of editable, so I just though it is funny to create ieatforms.com with a title of Edible Forms. Enjoy ;)</p>
      </header>

      <button className="donate-btn" onClick={() => window.open("https://www.paypal.me/Morrison851", "_blank")}>💚 Donate</button>

      {/* Search Box */}
      <div className="search-box">
        <input
          type="text"
          placeholder="Search forms by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="cards-container">
        {filteredItems.map(item => (
          <div key={item.link} className="card">
            <button className="card-header" onClick={() => toggleCard(item.link)}>
              <span>{item.name}</span>
              <span className="arrow">{expanded[item.link] ? "▲" : "▼"}</span>
            </button>
            {expanded[item.link] && getFieldInfo(item)}
          </div>
        ))}
      </div>

      <footer>&copy; 2025 Edible Forms. All rights reserved.</footer>
    </div>
  );
}
